import type { PropsWithChildren } from 'react';

const NavGroupContainer = ({ children }: PropsWithChildren) => (
  <div className="flex grow basis-0 flex-col gap-y-3">{children}</div>
);

export default NavGroupContainer;
